module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Join the adventure!"])},
        "detail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The power is in your hands now."])},
        "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["✨ Join The Beta ✨"])}
      },
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rejoignez l'aventure !"])},
        "detail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La balle est dans votre camp."])},
        "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["✨ Rejoindre La Beta ✨"])}
      }
    }
  })
  Component.options.__i18nBridge = Component.options.__i18nBridge || []
  Component.options.__i18nBridge.push('{"en":{"title":"Join the adventure!","detail":"The power is in your hands now.","button":"✨ Join The Beta ✨"},"fr":{"title":"Rejoignez l\u0027aventure !","detail":"La balle est dans votre camp.","button":"✨ Rejoindre La Beta ✨"}}')
  delete Component.options._Ctor
  
}
